<template>
  <el-dialog
    top="10vh"
    :title="$t('Fota.tips7')"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <div class="wrap">
      <div class="title">{{ $t('Fota.tips8') }}</div>
      <div class="explain">
        {{ $t('Fota.tips9') }}
      </div>
      <div class="label">{{ $t('Fota.tips10') }}</div>
      <div class="label">{{ $t('Fota.tips11') }}</div>
      <div class="label">{{ $t('Fota.tips12') }}</div>
      <div class="btn" @click="handleAdd('DEVICE')">{{ $t('Fota.startCreate') }}</div>
    </div>
    <div class="wrap">
      <div class="title">{{ $t('Fota.tips13') }}</div>
      <div class="explain">
        {{ $t('Fota.tips14') }}
      </div>
      <div class="label">{{ $t('Fota.tips15') }}</div>
      <div class="label">{{ $t('Fota.tips16') }}</div>
      <div class="label">{{ $t('Fota.tips17') }}</div>
      <div class="btn" @click="handleAdd('VERSION')">{{ $t('Fota.startCreate') }}</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    handleAdd(targetType) {
      this.$emit('update:visible', false)
      this.$emit('handleAdd', true, targetType)
    },
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss">
.el-dialog {
  .el-dialog__body {
    padding: 16px 20px 20px 20px;
    .wrap {
      position: relative;
      margin-top: 24px;
      .title {
        padding-left: 16px;
        width: 318px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        background-image: linear-gradient(
          270deg,
          rgba(51, 157, 255, 0) 0%,
          rgba(51, 157, 255, 0.2) 100%
        );
        border-radius: 7px 8px 8px 7px;
      }
      .explain {
        margin-top: 8px;
        margin-bottom: 8px;
        padding-left: 16px;
        width: 350px;
        line-height: 22px;
        font-size: 14px;
        color: #666666;
      }
      .label {
        padding-left: 16px;
        line-height: 22px;
        font-size: 14px;
        font-weight: 600;
        color: #333333;
      }
      .btn {
        position: absolute;
        top: 40px;
        right: 20px;
        width: 120px;
        height: 120px;
        line-height: 120px;
        font-size: 16px;
        color: #339dff;
        text-align: center;
        border: 2px solid rgba(51, 157, 255, 1);
        border-radius: 8px;
        cursor: pointer;
      }
    }
  }
}
</style>
